var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M126 286v546h775V286H126z m-27-60h829c18.225 0 33 14.775 33 33v600c0 18.225-14.775 33-33 33H99c-18.225 0-33-14.775-33-33V259c0-18.225 14.775-33 33-33z",
    fill: "#2F54EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M621.817 573.627a6 6 0 0 0-0.818-8.446L458.63 431.465a6 6 0 0 0-9.814 4.631V703.53a6 6 0 0 0 9.814 4.631L621 574.445a6 6 0 0 0 0.818-0.818z m-125.045 180.85c-28.138 23.172-69.732 19.147-92.904-8.99a66 66 0 0 1-15.053-41.957V436.096c0-36.45 29.55-66 66-66a66 66 0 0 1 41.957 15.053l162.37 133.717c28.137 23.172 32.163 64.766 8.99 92.904a66 66 0 0 1-8.99 8.99l-162.37 133.717z",
    fill: "#85A5FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M510.273 224.561l-150.2-180.735c-10.59-12.742-29.505-14.487-42.247-3.898-12.743 10.59-14.488 29.505-3.898 42.247l150.2 180.735c25.883 31.145 69.798 31.145 95.68 0L710.01 82.175c10.59-12.742 8.845-31.657-3.898-42.247s-31.657-8.844-42.247 3.898l-150.2 180.735c-0.673 0.81-1.248 1.31-1.696 1.583-0.448-0.274-1.023-0.774-1.695-1.583z",
    fill: "#2F54EB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLive);
export default __webpack_public_path__ + "static/media/live.4a91f45b423efe8853ee80cdf74bd183.svg";
export { ForwardRef as ReactComponent };